import { ChangeEvent, KeyboardEvent as ReactKeyboardEvent } from "react";
import TextareaAutosize from "react-textarea-autosize";

import s from "@/commands/AssistantOnly/Input.module.scss";

export type Props = {
  id?: string;
  disabled?: boolean;
  name?: string;
  maxLength?: number;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string | number;
  onKeyDown?: (e: ReactKeyboardEvent<HTMLTextAreaElement>) => void;
  onCompositionStart?: () => void;
  onCompositionEnd?: () => void;
  isMobile?: boolean;
};

export function Input({
  id,
  disabled,
  name,
  maxLength,
  onChange,
  value,
  onKeyDown,
  onCompositionStart,
  onCompositionEnd,
  isMobile = false,
}: Props): JSX.Element {
  const placeholder = disabled ? "お話しください" : "質問を入力してください";
  return (
    <TextareaAutosize
      className={[s.TextInput, isMobile ? s.Mobile : undefined].join(" ")}
      id={id}
      name={name}
      maxLength={maxLength}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onCompositionStart={onCompositionStart}
      onCompositionEnd={onCompositionEnd}
      minRows={1}
      maxRows={5}
    />
  );
}
